import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapDebugActions } from '@/lib/debug.js';

const errMessage = function (err) {
    let error = '';

    if (err.response) {
        if (err.response.data && err.response.data.errors) {
            err.response.data.errors.forEach((apiError) => {
                if (typeof apiError === 'string' || apiError instanceof String) {
                    error = apiError;
                } else {
                    if ('source' in apiError) {
                        let source = ((apiError.source.pointer) ? apiError.source.pointer : apiError.source.controller.substr(0,apiError.source.controller.length-1))
                        source = (source.charAt(0).toUpperCase() + source.substr(1).toLowerCase())
                        error = error + ((error.length > 0) ? '<br/>' : '' ) + apiError.status + ' - ' + source + ' ' + apiError.detail;
                    }
                }
            });
        } else error = err.response.status + ' - ' + err.response.statusText;

    } else error = err.message;

    return error;
}

const errHandler = function (err) {
	if (err.message == 'Network Error') {
		EventBus.$emit('network-error-event', '');
		mapDebugActions.debugObject ( {error: err }, 'handler.js' );
		return;
	} else {
		if  (err.status == 401) {
			EventBus.$emit('logout-event', '');
			mapDebugActions.debugObject ( {error: err }, 'handler.js' );
			return;
		}
	}

	mapNotificationEventActions.emitError( {msg: errMessage(err)} );
}

export {
    errMessage,
    errHandler
}
